var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ant-row ant-form-item ant-form-item-no-colon read-only-item"},[_c('div',{staticClass:"ant-form-item-label read-only-label"},[_c('label',{attrs:{"title":_vm.label}},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2)]),_c('div',{staticClass:"ant-form-item-control-wrapper text-ellipsis"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }